/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import {getFormDropdownOptions} from '../../helpers/formDropdownOptions';

function defineBlock(forms) {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField('is form valid')
                .appendField(new Blockly.FieldDropdown(forms), 'FORMSLUG');
            this.setPreviousStatement(false, null);
            this.setNextStatement(false, null);
            this.setOutput(true, 'Boolean');
            this.setOutputShape(Blockly.OUTPUT_SHAPE_HEXAGONAL);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Checks whether a form is valid.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#app-actions');
        }
    };
}

function defineGenerators() {
    return {
        JavaScript: function (block) {
            const formSlug = block.getFieldValue('FORMSLUG');
            const formDataGenyId = formSlug.split('<<<>>>')[0];
            const code = `(validationModule.validate("${formDataGenyId}").isValid)`;
            return [code, Blockly.JavaScript.ORDER_NONE];
        }
    };
}

const Validate = function (props) {
    const name = 'snap_action_validate_page_V3';
    Validate.blockName = name;

    const forms = getFormDropdownOptions(props.context);
    Blockly.Blocks[name] = defineBlock(forms);

    const generators = defineGenerators();
    for (const language in generators) {
        Blockly[language][name] = generators[language];
    }

    if (!forms.length) {
        return null;
    }

    return (
        <block type={name}></block>
    );
};

Validate.propTypes = {
    context: PropTypes.object.isRequired
};

export default Validate;